import { ModuleExtensions } from '@wix/premium-fed-sdk/@premium-module';
export const SwitchProductModuleContextExtension = ModuleExtensions.contextExtension({});
//# sourceMappingURL=context.extension.js.map